import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { useFirebase } from 'components/Firebase/index.js';
import useOrgId from 'hooks/useOrgId.js';

const useOrgGeneralSettings = (params = {}) => {
  const firebase = useFirebase();
  const orgId = useOrgId();
  const user = firebase.auth.currentUser;
  const uid = useSelector((state) => state.sessionState.authUser?.uid);
  const isSignedIn = Boolean(user);
  const { enabled = true, ...queryOptions } = params;
  const isQueryEnabled = !!(enabled && orgId && uid && isSignedIn && orgId !== 'no-team');

  return useQuery({
    ...queryOptions,
    queryKey: ['o', orgId, 'settings', 'general'],
    queryFn: async () => {
      const agent = await firebase.getAgent();
      const { body = {} } = await agent.get(`/o/${orgId}/settings/general`);
      return body;
    },
    enabled: isQueryEnabled,
  });
};

export default useOrgGeneralSettings;
